<!-- 代理商档案需要，新增的用户树 -->
<!-- 由getUserTree改用getUserTreeWithOutCampus_new函数获取数据 -->

<template>
  <div style="display: inline-block; width: 100%">
    <!-- 内部新增搜索框的策略 -->
    <el-input
      class="selectClass"
	    size="small"
      :placeholder="inputPlaceholder || $t('app.pleaseSelectUser')"
      v-model="lstUserName"
      v-popover:choseAgentPopover
      v-if="lstUserName && lstUserName != ''"
      readonly
    >
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i @click.stop="clearSelect" class="el-icon-circle-close" style="position: absolute;left: -16px;top: 14px;background-color: #ffffff;width: 20px;"></i>
          <i
            class="el-select__caret el-input__icon el-icon-arrow-up"
            :class="{
              'is-reverse': showAgentDropDown
            }"
          ></i>
        </span>
      </span>
    </el-input>
    <el-input v-else class="selectClass"  size="small" :placeholder="inputPlaceholder || $t('app.pleaseSelectUser')" readonly v-model="lstUserName"
      v-popover:choseAgentPopover>
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i class="el-select__caret el-input__icon el-icon-arrow-down" :class="{
            'is-reverse': showAgentDropDown
          }"></i>
        </span>
      </span>
    </el-input>
    <div class="popover">
      <el-popover popper-class="agent-popover" placement="bottom-start" ref="choseAgentPopover" trigger="click"
      @show="showAgentDepartmentPopover" @hide="hideAgentDepartmentPopover" :visible-arrow="false">
      <div style="background-color: #ffffff">
        <!-- <el-input class="keyword-search" :placeholder="searchPlaceholder">
          </el-input> -->
        <div class="scrollbar-wrapper">
          <!-- 内部文本-->
          <vueEasyTree :data="dataList" show-checkbox @check-change="handleCheckChange" node-key="id" height="200px" ref="userNameTree"
            :default-checked-keys="defaultCheckedKeys"
            :filter-node-method="filterNode">
          </vueEasyTree>
        </div>

        <el-input :placeholder="$t('app.pleaseEnterKeywordFilter')" v-model="filterText"></el-input>
      </div>
    </el-popover>
    </div>
  </div>
</template>

<script>
import { getUserTreeWithOutCampus_new } from "@/api/basicApi.js";
import vueEasyTree from "@wchbrad/vue-easy-tree"
import "@wchbrad/vue-easy-tree/src/assets/index.scss"

export default {
  data() {
    return {
      filterAgentTextClass: "",
      agentTreeData: [],
      showAgentDropDown: false,
      lstUserName: "",
      lstUserId: [],
      radios: [],
      dataList: [],
      defaultCheckedKeys: this.defaultValue,
      filterText: ""
    };
  },
  props: {
    isShowLabel: {
      type: Boolean,
      default: false
    },
    inputPlaceholder: {
      type: String,
      default: ""
    },
    isSingleChoice: {
      type: Boolean,
      default: false
    },
    defaultName: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: Array,
      default: ()=> [],
    },
    doClear: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    filterText(val) {
      this.$refs.userNameTree.filter(val);
    },
    defaultName(newVal, oldVal) {
      this.lstUserName = newVal
    },
    defaultValue(newVal, oldVal) {
      this.defaultCheckedKeys = newVal
    },
    doClear(newVal, oldVal) {
      this.clearSelect();
    }
  },
  components:{
		vueEasyTree,
	},
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      if (!data.label) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange(data) {
      // console.log(data);
    },
    traverse(val) {
      for (let item of val) {
        item.label = item.userName;
        item.id = item.id;
        item.children = item.childList
        // item.id = item.value
        if (item.children) {
          this.traverse(item.children);
        }
      }
    },
    async initData() {
      let res = await getUserTreeWithOutCampus_new();
      let result = res.data;
      this.traverse(res.data);
      // result = res.data.map(e => {
      //   if (e.childList) {
      //     let tempList = e.childList.map(e2 => {
      //       return {
      //         id: e2.id,
      //         label: e2.userName,
      //         children: e2.childList
      //       };
      //     });
      //     return {
      //       id: e.id,
      //       label: e.userName,
      //       children: tempList
      //     };
      //   } else {
      //     return {
      //       id: e.id,
      //       label: e.userName,
      //       children: e.childList
      //     };
      //   }
      // });
      // console.log("el-tree",result);
      this.dataList = result;
    },
    showAgentDepartmentPopover() {
      this.showAgentDropDown = true;
    },
    hideAgentDepartmentPopover() {
      this.showAgentDropDown = false;
      this.lstUserId = []; //置空一下
      this.lstUserName = "";
      let selectPeopleName = [];
      let selectIdArr = this.$refs.userNameTree.getCheckedKeys();
      let selectNodeArr = this.$refs.userNameTree.getCheckedNodes();
     
      console.log(selectNodeArr);
      if(selectIdArr[0] === 'dep_1') {
        selectIdArr.splice(0,1)
        selectNodeArr.splice(0,1)
      }
      if (selectNodeArr.length > 0) {
        selectNodeArr.map(item => {
          selectPeopleName.push(item["label"]);
        });
        this.lstUserName = selectPeopleName.join(",");
		selectIdArr.map(item=>{
           let arr =item.split('_')
		   if(arr.length==1){
			this.lstUserId.push(item)
		   }
		   if(arr.length>1&&arr[0]=='dep'){
			this.lstUserId.push(arr[1])
		   }
		})
        this.$emit("input", this.lstUserId); //必须在前面
        this.$emit("select", this.lstUserId);
      } else {
        this.lstUserName = "";
        this.lstUserId = [];
        this.$emit("input", []); //必须在前面
        this.$emit("select", []); //为了清空
      }
    },
    clearSelect() {
      this.$refs.userNameTree.setCheckedNodes([]);
      this.hideAgentDepartmentPopover();
      this.lstUserName = "";
    }
    // monitoring() {
    //   // 监听事件
    //   this.$on("clearSelect", res => {
    //     this.$refs.userNameTree.setCheckedNodes([]);
    //   });
    // },
  },
  mounted() {
    this.initData();
    // this.monitoring(); // 注册监听事件
  }
};
</script>

<style lang="scss" scoped>
.is-reverse {
  transform: rotate(-180deg);
}

.selectClass {
  width: 100%;

  :deep(.el-input__inner) {
    // height: 40px;
    // width: 15.3vw;
  }
}
// :deep(.el-popover) {
//   width: 100%;
// }
.scrollbar-wrapper {
  background-color: #ffffff;
  max-height: 250px;
  overflow: auto;
  padding-right: 10px;
  margin-bottom: 10px;
  // .el-scrollbar__wrap {
  //   margin-bottom: -30px !important;
  // }
}
</style>
<style lang="scss">
.agent-popover {
  max-height: 300px;
  // width: 9%;
  overflow-y: auto;
  transition: all .3s ease-out;
  .el-tree-node__label {
    font-size: 14px;
    overflow-y: auto;
  }
}

.popover {
  .el-popover {
    min-width: 100px !important;
  }
  .agent-popover:has(.is-expanded) {
    // width: auto !important;
    .el-tree-node__content{
      transition: all 0 ease-out;
    }
}
}
</style>
